import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as HomeIcon } from 'images/icons/iconHome.svg';
import { ReactComponent as ArchiveIcon } from 'images/icons/archive-view-icon.svg';
import { StyledListItemText, StyledMenuItemWrapper } from './SelectItem.styles';
import Tooltip from '../../tooltip';
import { ExpandButton } from '../ExpandButton';
import { DefaultButton } from '../DefaultButton';

// Type definitions for styled components props
interface StyledMenuItemWrapperProps {
  isLeftCheckbox?: boolean;
  isExpandButton?: boolean;
  children?: React.ReactNode;
}

interface StyledListItemTextProps {
  stylingVariant?: string;
  color?: any;
  style?: any;
  children?: React.ReactNode;
}

interface MenuItemInnerContentProps {
  isLeftCheckbox: boolean;
  isExpandButton: boolean;
  displayHomeIcon: boolean;
  displayArchiveIcon: boolean;
  memoizedCheckbox?: React.ReactNode | null;
  stylingVariant: string;
  option: {
    [key: string]: any;
    isDefault?: boolean | null;
  };
  classString: string;
  styleString: string;
  selectTitle: string;
  isAllMessagesExpanded: boolean;
  handleToggleExpandAllMessages: () => void;
  isSupportDefault: boolean;
  handleSetDefault: (option: MenuItemInnerContentProps['option']) => void;
}

export const MenuItemInnerContent: React.FC<MenuItemInnerContentProps> = ({
  isLeftCheckbox,
  isExpandButton,
  displayHomeIcon,
  displayArchiveIcon,
  memoizedCheckbox,
  stylingVariant,
  option,
  classString,
  styleString,
  selectTitle,
  isAllMessagesExpanded,
  handleToggleExpandAllMessages,
  isSupportDefault,
  handleSetDefault,
}) => (
  <StyledMenuItemWrapper {...({ isLeftCheckbox, isExpandButton } as StyledMenuItemWrapperProps)}>
    {displayHomeIcon && !displayArchiveIcon && <HomeIcon />}
    {displayArchiveIcon && <ArchiveIcon />}
    {memoizedCheckbox}
    <StyledListItemText
      {...({ stylingVariant, color: option?.[classString], style: option?.[styleString] } as StyledListItemTextProps)}
    >
      <Tooltip
        displayHomeIcon={displayHomeIcon}
        isTruncatedText
        title={selectTitle}
        text={selectTitle}
        placement="top"
      />
    </StyledListItemText>
    {isExpandButton && (
      <ExpandButton
        isAllMessagesExpanded={isAllMessagesExpanded}
        handleToggleExpandAllMessages={handleToggleExpandAllMessages}
      />
    )}
    {isSupportDefault && !isExpandButton && (
      <DefaultButton isDefault={option?.isDefault} handleSetDefault={() => handleSetDefault(option)} />
    )}
  </StyledMenuItemWrapper>
);

MenuItemInnerContent.propTypes = {
  isLeftCheckbox: PropTypes.bool.isRequired,
  isExpandButton: PropTypes.bool.isRequired,
  displayHomeIcon: PropTypes.bool.isRequired,
  displayArchiveIcon: PropTypes.bool.isRequired,
  memoizedCheckbox: PropTypes.any,
  stylingVariant: PropTypes.string.isRequired,
  option: PropTypes.object.isRequired,
  classString: PropTypes.string.isRequired,
  styleString: PropTypes.string.isRequired,
  selectTitle: PropTypes.string.isRequired,
  isAllMessagesExpanded: PropTypes.bool.isRequired,
  handleToggleExpandAllMessages: PropTypes.func.isRequired,
  isSupportDefault: PropTypes.bool.isRequired,
  handleSetDefault: PropTypes.func.isRequired,
};
